import { useState, useEffect } from "react";

const useDevice = () => {
  const [device, setDevice] = useState("");

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      setDevice("android");
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setDevice("ios");
    } else {
      setDevice("other");
    }
  }, []);

  return device;
};

export default useDevice;
